var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeaderboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 12.2167V13.5717C8.33018 13.8572 8.25374 14.1371 8.11132 14.3846C7.9689 14.6321 7.76528 14.8388 7.52 14.985C6.99928 15.3707 6.5757 15.8725 6.2829 16.4506C5.99011 17.0286 5.83617 17.667 5.83333 18.315",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 12.2167V13.5717C11.6698 13.8572 11.7463 14.1371 11.8887 14.3846C12.0311 14.6321 12.2347 14.8388 12.48 14.985C13.0007 15.3707 13.4243 15.8725 13.7171 16.4506C14.0099 17.0286 14.1638 17.667 14.1667 18.315",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.49998H16.25C16.8025 7.49998 17.3324 7.28049 17.7231 6.88979C18.1138 6.49908 18.3333 5.96918 18.3333 5.41665C18.3333 4.86411 18.1138 4.33421 17.7231 3.94351C17.3324 3.55281 16.8025 3.33331 16.25 3.33331H15",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 18.3333H16.6667",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7.50002C5 8.8261 5.52678 10.0979 6.46447 11.0356C7.40215 11.9732 8.67392 12.5 10 12.5C11.3261 12.5 12.5979 11.9732 13.5355 11.0356C14.4732 10.0979 15 8.8261 15 7.50002V2.50002C15 2.27901 14.9122 2.06704 14.7559 1.91076C14.5996 1.75448 14.3877 1.66669 14.1667 1.66669H5.83333C5.61232 1.66669 5.40036 1.75448 5.24408 1.91076C5.0878 2.06704 5 2.27901 5 2.50002V7.50002Z",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7.49998H3.75C3.19747 7.49998 2.66756 7.28049 2.27686 6.88979C1.88616 6.49908 1.66667 5.96918 1.66667 5.41665C1.66667 4.86411 1.88616 4.33421 2.27686 3.94351C2.66756 3.55281 3.19747 3.33331 3.75 3.33331H5",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboardIcon);
export default __webpack_public_path__ + "static/media/LeaderboardIcon.085d858fe10cb317e4bc1825d0ab04d1.svg";
export { ForwardRef as ReactComponent };